const ExpansionPanelStylesRegular = {
  panel: {
    boxShadow: '0 4px 8px rgba(0,0,0,0.12)',
    borderRadius: '3px',
    '&&:not(:last-child)': {
      margin: '0 0 24px 0 !important',
    },
    '&&:before': {
      display: 'none',
    },
  },
  panelSummary: {
    padding: '24px',
    minHeight: 'auto !important',
    '&& > div': {
      margin: 0,
      padding: 0,
    },
  },
  extendedDetails: {
    padding: '0 24px 24px',
  },
};

const ExpansionPanelStylesCompressed = {
  ...ExpansionPanelStylesRegular,
  panel: {
    margin: '0 !important',
    boxShadow: 'none',
    '&&:not(:last-child)': {
      borderBottom: '1px solid rgba(178,178,178,0.5)',
    },
  },
};


export default {
  compressed: ExpansionPanelStylesCompressed,
  regular: ExpansionPanelStylesRegular,
};
